import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import { REACT_INTL_PROP_TYPE } from 'constants/propTypes'
import { TYPE_CONTINUOUS, TYPE_DISCRETE } from 'constants/indicators'
import IndicatorBar from './IndicatorBar'
import './indicator.scss'

class Indicator extends Component {
  getIndent(position, start, end) {
    return (position < 5 && start ? -50 : 0) || (position > 95 && end ? 50 : 0)
  }

  getContinuous(bar, index) {
    const start = bar.from
    const end = bar.to
    const value = bar.metric_value
    const percent = 100
    let result = 0

    if (start && end && (value || value === 0)) {
      result = this.positionLimits(((end - value) * percent) / (end - start))
    } else if ((value || value === 0) && end && !start) {
      result = this.positionLimits(((end - value) * percent) / end)
    } else if ((value || value === 0) && start && !end) {
      result = this.positionLimits(((value - start) * percent) / start)
      result = percent - result
    }

    const indent = this.getIndent(result, start, end)
    const fixedValue =
      typeof value === 'number' && !Number.isInteger(value)
        ? value.toFixed(2)
        : value

    return (
      <IndicatorBar
        key={index}
        bar={bar}
        position={result}
        textIndent={indent}
        topBarValue={fixedValue}
        bottomBarValue={bar.to}
      />
    )
  }

  getDiscrete(bar, index) {
    const {
      intl: { formatMessage },
    } = this.props
    const position = 50
    const indent = 0
    const { values, metric_value } = bar
    const label = Array.isArray(values)
      ? values.map(i => formatMessage({ id: i })).join(', ')
      : ''
    const formattedMessage =
      metric_value &&
      typeof metric_value === 'string' &&
      metric_value.includes('_')
    const metricValue = formattedMessage
      ? formatMessage({ id: metric_value })
      : label

    return (
      <IndicatorBar
        key={index}
        bar={bar}
        position={position}
        textIndent={indent}
        topBarValue={metricValue}
        bottomBarValue={label}
        className="ma-indicator-bar-discrete"
      />
    )
  }

  getIndicators() {
    const {
      indicator_health_bar: { segments, type },
    } = this.props

    return segments.reduce((total, bar, index) => {
      const result = [...total]

      if (type === TYPE_CONTINUOUS) {
        result.push(this.getContinuous(bar, index))
      }

      if (type === TYPE_DISCRETE) {
        result.push(this.getDiscrete(bar, index))
      }

      return result
    }, [])
  }

  positionLimits(value) {
    return (value > 100 ? 100 : value) || (value < 0 ? 0 : value)
  }

  render() {
    const { className } = this.props

    return (
      <div className={cn('ma-indicator', { [className]: className })}>
        {this.getIndicators()}
      </div>
    )
  }
}

Indicator.propTypes = {
  intl: REACT_INTL_PROP_TYPE.isRequired,
  indicator_health_bar: PropTypes.shape({
    segments: PropTypes.array,
    type: PropTypes.string,
  }),
  className: PropTypes.string,
}

Indicator.defaultProps = {
  indicator_health_bar: {
    segments: [],
    type: null,
  },
  className: null,
}

export default injectIntl(Indicator)
